import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function ArticlePreview() {
  const featuredArticles = getFeaturedArticles().slice(0, 4);

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-14">
          <div>
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-4">
              精选文章
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
              热门推荐
            </h2>
          </div>
          <Link
            to="/category/news"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200 no-underline whitespace-nowrap"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuredArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}